import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { getStavZakazka } from '@/modules/servis/zakazka/utils';

import { NAME as name, DEPENDENT_TABLES as depTableNames, CRUMB_LABEL_KEY, ZAKAZKA_STAV } from '../../constants';
import { apiProvider } from '../../api';
import { actions } from './actions';
import { mutations } from './mutations';
import { ZakazkaDropdownList, Edit, LocalState, depTableSettings, props } from './state';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: new ZakazkaDropdownList(),
	edit: new Edit(),
	depTableNames,
	depTableSettings,
	localState: new LocalState(),
	extraActions: actions,
	extraGetters: {
		isZakazkaDisabled(state) {
			const stav: ZAKAZKA_STAV = getStavZakazka(state.edit);
			return stav === ZAKAZKA_STAV.UVOLNENA || stav === ZAKAZKA_STAV.UZAVRENA || stav === ZAKAZKA_STAV.VYRAZENA;
		},
		toInterni(state) {
			return state.edit.PodilMatInt === 100 && state.edit.PodilSlzInt === 100;
		},
		toGarance(state) {
			return state.edit.PodilMatGd === 100 && state.edit.PodilSlzGd === 100;
		},
	},
	extraMutations: mutations,
	props,
});

export const storeEdit = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: new ZakazkaDropdownList(),
	edit: new Edit(),
	depTableNames,
	depTableSettings,
	localState: new LocalState(),
	extraActions: actions,
	extraGetters: {
		isZakazkaDisabled(state) {
			const stav: ZAKAZKA_STAV = getStavZakazka(state.edit);
			return stav === ZAKAZKA_STAV.UVOLNENA || stav === ZAKAZKA_STAV.UZAVRENA || stav === ZAKAZKA_STAV.VYRAZENA;
		},
		toInterni(state) {
			return state.edit.PodilMatInt === 100 && state.edit.PodilSlzInt === 100;
		},
		toGarance(state) {
			return state.edit.PodilMatGd === 100 && state.edit.PodilSlzGd === 100;
		},
	},
	extraMutations: mutations,
	props,
});
